import { LOAD_COMPANY, SELECT_COMPANY, CLEAN_SELECTED_COMPANY } from "./actionTypes";

export const loadCompanies = companies => ({
    type: LOAD_COMPANY,
    companies
});

export const chooseCompany = company => ({
    type: SELECT_COMPANY,
    company
});

export const cleanCompany = () => ({
    type: CLEAN_SELECTED_COMPANY
});